import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

export const Content = styled.div`
  border: 1px solid ${tokens.colors.gray};
  border-radius: 6px;
  padding: ${tokens.space.regular};
  box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.24);
  background-color: ${tokens.colors.white};
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  h2 {
    margin: 0 !important;
  }

  &:hover {
    background-color: $pm-gray-light;
  }

  // BUG:: This hides the anchor heading links
  h1:hover,
  h2:hover,
  h3:hover {
    &:before {
      display: none;
    }
  }
`;

export const SeeMore = styled.span`
  text-align: right;
`;
